import React, { useCallback } from 'react';
import { Icon, icons, AppShell, Colors, Mantine } from '@tapresearch/ui/components';
import { logout } from '../../organization_dashboard/api/UserApi';

export const AccountMenu = ({ user, asset }) => {
  const { is_ops = false } = user;
  const { customer } = user.organization;
  const { is_admin, is_active } = user.organization_membership;
  const { can_developer_survey } = user.organization;
  const isBannedCustomer =
    customer &&
    customer.insights_moderation_status ===
      asset.constants.INSIGHTS_MODERATION_STATUS_BANNED;

  const showPayments =
    !can_developer_survey &&
    is_admin &&
    is_active &&
    customer &&
    customer.customer_type === asset.constants.CUSTOMER_TYPE_PERSONAL;

  const onNavigate = useCallback((url) => {
    window.location.href = url;
  }, []);

  return (
    <>
      {is_active && !isBannedCustomer && (
        <>
          {!!customer && !can_developer_survey && (
            <>
              <AppShell.NavbarUserMenuItem
                onClick={() => onNavigate(`/ops/customers/dashboard`)}
                iconKey={icons.tr.TapCircleIcon}
                my={5}
                py={7}
                sx={(theme) => ({
                  fontSize: theme.fontSizes.sm,
                  fontWeight: 500,
                })}
                rightSection={
                  <Icon boxSize={5} color="gray.200" icon={icons.fa.LongArrowAltRight} />
                }
              >
                Market Sample
              </AppShell.NavbarUserMenuItem>
              <Mantine.Menu.Divider />
            </>
          )}
          {is_ops && (
            <AppShell.NavbarUserMenuItem
              onClick={() => onNavigate('/organizations/manage')}
              iconKey={icons.io5.Business}
            >
              Manage
            </AppShell.NavbarUserMenuItem>
          )}

          <AppShell.NavbarUserMenuItem
            onClick={() =>
              onNavigate(`/organizations/${user.organization.identifier}/team`)
            }
            iconKey={icons.fi.Users}
          >
            Team
          </AppShell.NavbarUserMenuItem>
          {!!showPayments && (
            <AppShell.NavbarUserMenuItem
              onClick={() =>
                onNavigate(
                  `/organizations/${user.organization.identifier}/payments`
                )
              }
              iconKey={icons.io5.WalletOutline}
            >
              Billing
            </AppShell.NavbarUserMenuItem>
          )}
          <AppShell.NavbarUserMenuItem
            onClick={() =>
              onNavigate(
                `/organizations/${user.organization.identifier}/account`
              )
            }
            iconKey={icons.fi.User}
          >
            Profile
          </AppShell.NavbarUserMenuItem>
        </>
      )}

      <Mantine.Menu.Divider />

      <AppShell.NavbarUserMenuItem
        color="red"
        sx={{ color: Colors.red['500'] }}
        onClick={() => logout()}
        iconKey={icons.fi.LogOut}
      >
        Sign out
      </AppShell.NavbarUserMenuItem>
    </>
  );
};
